module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_pp2_8017.f702e8ca.png";